import { BaseModel } from '../base-model';
import { IEvent } from '.';
import { Moment } from 'moment';
import { DataHelper } from '../../utils/data-helper';

export interface IAppointmentException {
  StartTime: string;
  ExceptionDate: string;
  EndTime: string;
  MasterId: number;
  IsAllDay: boolean | false
}
export class AppointmentException extends BaseModel<IAppointmentException> implements IAppointmentException {
  StartTime: string;
  ExceptionDate: string;
  EndTime: string;
  MasterId: number;
  IsAllDay: boolean | false;
  constructor(event: IEvent, exceptionDate: Moment, option?: IAppointmentException) {
    super(option);
    this.StartTime = DataHelper.formatDateTime(event.start);
    this.EndTime = DataHelper.formatDateTime(event.end);
    this.MasterId = event.originId;
    this.ExceptionDate = DataHelper.formatDateTime(exceptionDate);
    this.IsAllDay = event.allDay || false;
  }
}